import { useRef, useEffect, useCallback, useState, useContext } from "react";
import "./RelatedProducts.css";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import { getPageImageLimit } from "../../config/pageDetails";

const RelatedProducts = ({ productReference }) => {
  const { t } = useContext(LanguageContext);
  const productLimit = getPageImageLimit("relatedProducts", "productLimit") || 6;
  
  const navigate = useNavigate();
  const [productsData, setProductsData] = useState([]);
  const scrollRef = useRef(null);

  const fetchData = useCallback(async () => {
    try {
      const requestObject = {
        categoryId: productReference.categoryId,
        subCategoryId: productReference.subCategoryId,
        getCount: false,
      };

      const response = await fetch(
        `/api/products?offset=0&limit=${productLimit}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestObject),
        }
      );

      if (!response.ok) return;
      const result = await response.json();
      setProductsData(result.products);
    } catch (err) {
      console.error(err);
    }
  }, [productLimit, productReference]);

  useEffect(() => {
    if (productReference?.categoryId && productReference?.subCategoryId) {
      fetchData();
    }
  }, [productReference, fetchData]);

  const scroll = (dir) => {
    scrollRef.current?.scrollBy({
      left: dir === "left" ? -320 : 320,
      behavior: "smooth",
    });
  };

  return (
    <div className="related-products-container">
      <div className="related-products-header">
        <h2>{t("relatedProducts.relatedProducts")}</h2>
        <div className="partion-line-related-products" />
        {console.log("Product Reference Object:", { categoryId: productReference.categoryId, subCategoryId: productReference.subCategoryId, name: productReference.subCategoryName, metaData: productReference.subCategoryMetadata })}
        <button className="view-more-btn" onClick={() => navigate(`/products`, { state: { subCategory: { categoryId: productReference.categoryId, subCategoryId: productReference.subCategoryId, name: productReference.subCategoryName, metaData: productReference.subCategoryMetadata } } })}>
          {t("relatedProducts.viewMore")}
        </button>
      </div>

      <div className="related-products-carousel-wrapper">
        <button className="arrow-btn left" onClick={() => scroll("left")}>
          ‹
        </button>

        <div className="related-products-carousel" ref={scrollRef}>
          {productsData?.map((product) => (
            <div
              key={product.productId}
              className="product-card"
              onClick={() => navigate(`/product/${product.productId}`)}
            >
              <div className="product-image-wrapper">
                <img
                  src={product.imageUrl[0]}
                  alt={product.name}
                  className="product-img"
                />
                <div className="hover-overlay">
                  <button className="hover-btn">{t("relatedProducts.viewDetails")}</button>
                </div>
              </div>

              <p className="product-name">{product.name}</p>
              <p className="product-category">{product.description}</p>
            </div>
          ))}
        </div>

        <button className="arrow-btn right" onClick={() => scroll("right")}>
          ›
        </button>
      </div>
    </div>
  );
};

export default RelatedProducts;
